import { render, staticRenderFns } from "./CalculateMonthly.vue?vue&type=template&id=b4e4f97a&scoped=true"
import script from "./CalculateMonthly.vue?vue&type=script&lang=js"
export * from "./CalculateMonthly.vue?vue&type=script&lang=js"
import style0 from "./CalculateMonthly.vue?vue&type=style&index=0&id=b4e4f97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e4f97a",
  null
  
)

export default component.exports